import { render, staticRenderFns } from "./tenant-role-add-or-update.vue?vue&type=template&id=954c58ca&"
import script from "./tenant-role-add-or-update.vue?vue&type=script&lang=js&"
export * from "./tenant-role-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports